import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=d6531d04&scoped=true"
import script from "./NewHeader.vue?vue&type=script&lang=ts"
export * from "./NewHeader.vue?vue&type=script&lang=ts"
import style0 from "./NewHeader.vue?vue&type=style&index=0&id=d6531d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6531d04",
  null
  
)

export default component.exports